const keys = require('translations/en.json');

export function translation(key: string): string {
  return keys[key] || key;
}

export default translation;
